export const API_PATH = "https://clinicaltrials-api.oncoassist.com/api/";